module.exports = __webpack_public_path__ + "img/特产店铺5.6e9c11d5.png";